import styled from "@emotion/styled";
import tw from "tailwind.macro";

export const NoDataViewContainer = styled.div`
  ${tw`text-center m-4`}
`;

export const NoDataViewText = styled.p`
  ${tw`text-xl`}
`;
